import * as constants from "../constants/CONSTANT";
import authApi from "./authApi";
import axios from "axios";
import { getToken, getAxios, getAxiosMultipart } from "../utils/helper";

// const getBaseApiUrl = () => {
//  const tenantCode = sessionStorage?.getItem("schoolcode") ?? "";
//  return `http://103.159.182.162:4010`;
// };

const getBaseApiUrl = () => {
  const tenantCode = sessionStorage?.getItem("schoolcode") ?? "";
  //  return `https://d7nql637-4010.inc1.devtunnels.ms`;
  //  return `https://crm.idigischool.com/ibs`;
  return window.location.hostname === "localhost"
    ? "http://localhost:4010/ibs"
    : `https://crm.idigischool.com/ibs`;

  //  return `http://localhost:4010/ibs`;
};

console.log("getBaseApiUrl-<", getBaseApiUrl);

const schoolApi = {
  //************* User****************************/
  async handleUnauthorized(method) {
    try {
      return await method();
    } catch (error) {
      if (
        // error.response &&
        error?.response?.status === 401 //&&
        // error.response.data.errors === "Please authenticate"
      ) {
        // window.location.href = "/login"; // Redirect to login page
        authApi.logout();
      } else {
        console.error("Error:", error);
        throw error;
      }
    }
  },

  //fetchTimetableRecords
  async fetchTimetableRecords(classId = null, sectionId = null) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${getBaseApiUrl()}/api/timetable/classid/${classId}/sectionid/${sectionId}`
      );

      return data;
    });
  },
  //getAllSetting
  async getAllSetting() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${getBaseApiUrl() + "/api/settings/"}`
      );
      return data;
    });
  },
  //.................... Fetch Users ...................................
  async fetchUsers() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(`${getBaseApiUrl() + "/api/auth"}`);
      if (data.status === 401) {
        authApi.logout();
      }

      if (data.length > 0) {
        return data;
      }
      return null;
    });
  },

  //.................... Fetch Login Users ...................................
  async getLoginUserData() {
    return await this.handleUnauthorized(async () => {
      console.log("getLoginUserData");
      const instance = getAxios();
      const { data } = await instance.get(
        `${getBaseApiUrl() + "/api/auth/profile_schema_user"}`
      );
      console.log("datata=>", data);
      if (data.status === 401) {
        authApi.logout();
      }

      if (data) {
        return data;
      }
      return null;
    });
  },

  //.................... Save Login Users ...................................
  async saveUser(user) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${getBaseApiUrl() + "/api/auth/" + user.id}`,
        user
      );

      if (data) {
        return data;
      }
      return null;
    });
  },
  //.................... Fetch Schema User By Id...................................
  async getSchemaUserById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${getBaseApiUrl() + "/api/students/schemauser/" + id}`
      );
      if (data.status === 401) {
        authApi.logout();
      }

      if (data) {
        return data;
      }
      return null;
    });
  },

  //.................... Update Login Users ...................................
  async updateUser(user) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${getBaseApiUrl() + "/api/auth/change/updatepassword"}`,
        user
      );
      if (data) {
        return data;
      }
      return null;
    });
  },

  //ResetPassword
  async ResetPassword(email, password, school_code, id) {
    console.log("updated passsword == ", password);
    console.log("updated passsword == ", id);
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${getBaseApiUrl()}/api/auth/updatepassword/user`,
        { email, password, school_code, id }
      );
      return data;
    });
  },
  //.......... Fetch All Users ..........................................
  async fetchUsers() {
    return await this.handleUnauthorized(async () => {
        console.log("getBaseApiUrl()", getBaseApiUrl());
        const instance = getAxios();
      const { data } = await instance.get(
        `${getBaseApiUrl() + "/api/auth/users/all"}`
      );
      if (data.length > 0) {
        return data;
      }
    });
  },
  //Show Image Logo on Print Priview
  async urlToDataUrl(img) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${getBaseApiUrl() + "/api/files/company/logoimg"}`
      );
    });
  },
  //.............. Fetch User By Id .............................
  async fetchStaffById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${getBaseApiUrl() + "/api/auth/" + id}`
      );
      if (data.length > 0) {
        return data;
      }
    });
  },

  async saveStaffMember(staffMember) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.put(
        `${getBaseApiUrl() + "/api/auth/" + staffMember.id}`
      );
      if (data.length > 0) {
        return data;
      }
    });
  },
  //............. Delete User ............................
  async deleteUser(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.delete(
        `${getBaseApiUrl() + "/api/auth/" + id}`
      );
      if (data.length > 0) {
        return data;
      }
    });
  },

  //************************ Student ***********************************//

  //................... Student by Parent Id  ................................
  async fetchStudentsByParentId(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${getBaseApiUrl() + "/api/students/parent/" + id}`
      );
      return data;
    });
  },

  //...................  Student By Id  ................................
  async fetchStudentsById(id, sessionid) {
    return await this.handleUnauthorized(async () => {
      console.log("fetchStudentsById66888==>>", id);
      const instance = getAxios();
      const { data } = await instance.get(
        `${getBaseApiUrl() + "/api/students/" + id + "/" + sessionid}`
      );
      if (data) {
        return data;
      }
    });
  },

  async getStudentRecords(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${getBaseApiUrl()}/api/students/${id}`
      );
      return data;
    });
  },
  /*   End */

  //************************ Events ***********************************//

  //...................  Student By Id  ................................
  async fetchEvents() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${getBaseApiUrl() + "/api/events/getallevents"}`
      );
      return data;
    });
  },

  //getAssignTransportByIdOrStudentid
  async getAssignTransportByIdOrStudentid(record, session_id) {
    return await this.handleUnauthorized(async () => {
      const id = record;
      const sessionid = session_id !== undefined && session_id !== 'undefined' ? session_id : null;
      const instance = getAxios();
      const { data } = await instance.get(
        `${getBaseApiUrl() + "/api/assigntransport/id/" + id + "/" + sessionid}`
      );
      return data;
    });
  },
  ///////////////////////
  /*   End */

  //************************ Session ***********************************//

  //...................  Sessions  ................................
  async fetchSessions() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${getBaseApiUrl() + "/api/sessions/session"}`
      );
      return data;
    });
  },

  ///////////////////////
  /*   End */

  //************************ Fee ***********************************//

  //...................  Fee Deposites  ................................
  async fetchFeeDeposits(id) {
    return await this.handleUnauthorized(async () => {
      console.log("Id FeeDeposit =>", id);
      const instance = getAxios();
      const { data } = await instance.get(
        `${getBaseApiUrl() + "/api/feedeposites/studentaddmission/" + id}`
      );
      return data;
    });
  },
  //......................getfeereciptdata...........................
  async getfeereciptdata(stuAddId) {
    console.log("getfeereciptdata@@=>", stuAddId);
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      if (stuAddId) {
        const { data } = await instance.get(
          `${getBaseApiUrl() + "/api/feedeposites/studentAddId/" + stuAddId}`
        );
        console.log("data12233==>", data);
        return data;
      }
    });
  },
  //getAttendanceAllRecordForMonthly
  async getAttendanceAllRecordForMonthly(id, year) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      console.log("id ->", id);
      console.log("year ->", year);

      const { data } = await instance.get(
        `${getBaseApiUrl()}/api/attendance/attInfo/${id}/${year}`
      );
      return data;
    });
  },

  ///////////////////////
  /*   End */

  //downloadFiles
  async downloadFiles(file) {
    console.log("file=======????", file);
    try {
      return await this.handleUnauthorized(async () => {
        const instance = getAxios();
        const response = await instance.get(
          `${getBaseApiUrl()}/api/files/${file}/download`,
          { responseType: "blob" } // Important for binary data
        );
        console.log("response.data  =======>", response.data);
        return response.data;
      });
    } catch (error) {
      console.error("Error fetching filtered student data:", error);
      throw error;
    }
  },

  //getAllAnouncement
  async getAllAnouncement(userId) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const url = userId 
        ? `${getBaseApiUrl()}/api/anouncements/user/${userId}`
        : `${getBaseApiUrl()}/api/anouncements`;
      const { data } = await instance.get(url);
      return data;
    });
  },
  //************************ Assigments ***********************************//

  //...................  Assigments With ClassId................................
  async fetchAssignmentsClassWise(id, sessionid) {
    try {
      return await this.handleUnauthorized(async () => {
        const instance = getAxios();
        const url = `${getBaseApiUrl()}/api/assignments/${id}/${sessionid}`;

        const { data } = await instance.get(url);
        return data;
      });
    } catch (error) {
      // Handle any errors here
      console.error("Error fetching assignments:", error);
      throw error; // You may want to handle or log the error as needed
    }
  },

  //...........Fetch Assigment Date Wise...............
  async searchAssimentsRecords(assigmentDetails, selectedSessionId) {
    try {
      return await this.handleUnauthorized(async () => {
        const instance = getAxios();
        // Construct the base URL
        let url = `${getBaseApiUrl()}/api/assignment/assignments/${selectedSessionId}/${assigmentDetails.classid
          }/${assigmentDetails.section_id}`;

        if (assigmentDetails.fromdate) {
          url += `/${assigmentDetails.fromdate}`;
        }
        if (assigmentDetails.todate) {
          url += `/${assigmentDetails.todate}`;
        }

        const { data } = await instance.get(url);

        console.log("API Data of Single Payment", data);

        return data;
      });
    } catch (error) {
      console.error("Error fetching payment records:", error);
      return null;
    }
  },
  ///////////////////////
  /*   End */

  //*********************** Exam **************************** */

  //...........Fetch Exam Schedule Details All Titles ...............
  async searchExamScheduleRecords(session_id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${getBaseApiUrl() + "/api/exams/examtitle/" + session_id}`
      );
      return data;
    });
  },

  //................... Exam Schedule By Id   ................................
  async fetchExamscheduleById(examTitleId, classId) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${getBaseApiUrl()}/api/exams/schedule/${examTitleId}/${classId}`
      );
      console.log("dataaa", data);
      return data;
    });
  },

  ///////////////////////
  /*   End */

  //*********************** Student Attendance  **************************** */

  //...........Student Attendance Month Wise Count of Present and Absent. ...............

  async studentAttendanceByMonth(attendanceReport) {
    try {
      return await this.handleUnauthorized(async () => {
        console.log("studentAttendanceByMonth@@=>", attendanceReport);
        const instance = getAxios();
        const url = `${getBaseApiUrl()}/api/attendance_line_item/studentid/${attendanceReport.studentAdmissionid}/session_id/${attendanceReport.sessionid}`;

        const { data } = await instance.get(url);
        // attendance_line_item/student_id/0a765803-8d16-43f7-b649-f1d9bc00ed96/month/April
        console.log("API Data of Single attendanceReport", data);
        return data;
      });
    } catch (error) {
      console.error("Error fetching attendance records:", error);
      return error;
    }
  },

  /*   End */

  //*********************** Student Time Table  **************************** */

  //...........Student Time Table Records.................

  async getTimeTableRecord(classId, sectionId) {
    console.log("classId", classId);
    console.log("sectionId", sectionId);
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${getBaseApiUrl()}/api/timetable/classid/${classId}/sectionid/${sectionId}`
      );
      return data;
    });
  },

  //...........Student Time Table Records By Section Id .................

  async getSectionRecordById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${getBaseApiUrl() + "/api/section/class/" + id}`
      );
      return data;
    });
  },

  //...........Student Classes Records.................
  async getClassRecords() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${getBaseApiUrl() + "/api/classes"}`
      );

      if (data.length > 0) {
        return data;
      }
    });
  },

  //.........................Fee Api's Starts Here...................................

  //...........Student Fee Intsallment Records.................
  async getStudentFeeIntsallmentRecords(studentid, sessionId) {
    const normalizedSessionId =
      sessionId !== undefined && sessionId !== null && sessionId !== "undefined"
        ? sessionId
        : null;

    if (!studentid) {
      return { success: false, message: "Missing student admission id" };
    }
    if (!normalizedSessionId) {
      return { success: false, message: "Missing or invalid session id" };
    }

    console.log("ID Session", normalizedSessionId);
    console.log("ID studentAddmisionId", studentid);
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${getBaseApiUrl()}/api/studentfeeinstallments/webandmobile/${studentid}/${normalizedSessionId}`
      );
      console.log("datttaa=>", data);
      return data;
    });
  },

  async createFeeDeposit(feeDeposit) {
    try {
      return await this.handleUnauthorized(async () => {
        const instance = getAxios();
        const { data } = await instance.post(
          `${getBaseApiUrl() + "/api/feedeposites/"}`,
          feeDeposit
        );
        if (data.success) {
          return data;
        }
      });
    } catch (error) {
      console.error("Error during fatch:", error);
      // toast.error(error.response.data.message);
    }
  },
  async FeeDepositOnline(amount) {
    try {
      console.log("amount ->", amount);
      return await this.handleUnauthorized(async () => {
        const instance = getAxios();
        const { data } = await instance.post(
          `${getBaseApiUrl() + "/api/feedeposites/onlinepayment"}`,
          { amount }
        );
        console.log("datatyrwt=>", data);
        return data;
      });
    } catch (error) {
      console.error("Error during fatch:", error);
    }
  },

  async getStudentResult(classId, admissionId, session_id) {
    const instance = getAxios();
    return await this.handleUnauthorized(async () => {
      const { data } = await instance.get(
        `${getBaseApiUrl() + "/api/results/" + classId + "/" + admissionId + "/" + session_id}`
      );
      return data;
    });
  },

  async getStudentallResult(classId, admissionId, sessiond_id) {
    // console.log("----------------")
    // console.log("ClassId AND Addmision Id :--", classId, admissionId);
    const instance = getAxios();
    return await this.handleUnauthorized(async () => {
      const { data } = await instance.get(
        `${getBaseApiUrl() + "/api/results/mobile_app/" + classId + "/" + admissionId + "/" + sessiond_id
        }`
      );
      // console.log("Data",data)
      return data;
    });
  },

  async deleteFile(id) {
    console.log("deleteFile@@!=>", id);
    return await this.handleUnauthorized(async () => {
      const token = sessionStorage.getItem("token");
      let response = await fetch(getBaseApiUrl() + "/api/files/" + id, {
        method: "DELETE",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });
      return await response.json();
    });
  },

  async saveFiles(fileId, formData) {
    console.log("saveFiles=======>", fileId, formData);
    return await this.handleUnauthorized(async () => {
      const token = sessionStorage.getItem("token");
      let response = await fetch(getBaseApiUrl() + "/api/files/" + fileId, {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: formData,
      });

      return await response.json();
    });
  },

  async createFile(parentId, selectedFiles) {
    console.log("parentId, selectedFiles", parentId, selectedFiles);
    return await this.handleUnauthorized(async () => {
      const token = sessionStorage.getItem("token");
      let response = await fetch(getBaseApiUrl() + "/api/files/" + parentId, {
        method: "POST",
        mode: "cors",
        headers: {
          Authorization: token,
        },
        body: selectedFiles,
      });
      const result = await response.json();
      return result;
    });
  },

  async getSessionById(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${getBaseApiUrl() + "/api/sessions/session/" + id}`
      );
      console.log("check kr -->", data);
      if (data.success) {
        return data;
      }
    });
  },

  async ForgetPasswordApi(credentials) {
    console.log("password email == ", credentials.email);
    console.log("school_code == ", credentials.school_code);

    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${getBaseApiUrl()}/api/auth/forgot-password`,
        {
          email: credentials.email,
          school_code: credentials.school_code,
        }
      );
      console.log("password data == ", data);
      return data;
    });
  },

  async CheckOtp(email, school_code, otp) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.post(
        `${getBaseApiUrl()}/api/auth/check-otp`,
        { email, school_code, otp }
      );
      return data;
    });
  },

  async fetchFeeDepositsByStudentId(
    studentAddmissionid,
    session_id,
    deposit_id
  ) {
    try {
      return await this.handleUnauthorized(async () => {
        console.log("inside schoooool API", studentAddmissionid);
        const instance = getAxios();
        let uri = `/api/feedeposites/studentaddmission/${studentAddmissionid}/${session_id}`;
        if (deposit_id) {
          uri += `/${deposit_id}`;
        }
        console.log("uri-->", uri);
        const { data } = await instance.get(`${getBaseApiUrl()}${uri}`);
        return data;
      });
    } catch (error) {
      console.error("Error during fatch:", error);
    }
  },
  async findAdmissionByStudentId(id) {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(
        `${getBaseApiUrl() + "/api/studentaddmissions/student_id/" + id}`
      );
      return data;
    });
  },

  async fetchApprovedTasks() {
    return await this.handleUnauthorized(async () => {
      const instance = getAxios();
      const { data } = await instance.get(`${getBaseApiUrl()}/api/tasks?status=Approved`);
      return data;
    });
  },
  ///////////////////////
  /*   End */
};

export default schoolApi;
